import blocks from 'src/js/modules/blocks';
import isImageContainer from './is-image-container';
import hasBackgroundContainer from './has-background-container';
import { getSettings } from '../settings';

const getPosition = (blockNode) => {
  const settings = getSettings();
  if (blocks.verifiers.isWsBlock(blockNode) || hasBackgroundContainer(blockNode)) {
    const backgroundContainer = blockNode.querySelector(settings.backgroundContainer);
    return backgroundContainer.position;
  }

  if (isImageContainer(blockNode)) {
    return blockNode.contentPosition;
  }

  return [50, 50];
};

export default getPosition;
